import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './IndexConstituents.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function IndexConstituents(props) {
    const [data, setData] = useState([]);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let optionInfoMarket = "Index Constituents";
    let optionTypeComp = "Daily Market Tracker";
    // const [valuebtn, setValueBtn] = useState("G");
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    // useEffect(() => {
    //     setTimeout(() => {
    //         eleBtn.classList.add('active');
    //         eleLi.classList.add('active');
    //     })
    // }, [])
    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "IndexConstituents";
            fetch(`${getUrl}/${groupValue}/${groupIndex}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);

                    setloadingshow(false);
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "IndexConstituents";
            fetch(`${getUrl}/${groupValue}/${groupIndexNSE}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //console.log(getData, "getData")

                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, groupIndex, groupIndexNSE]);


    // setTimeout(() => {
    //     eleLi = document.getElementById('liDay');
    //     eleBtn = document.getElementById('btnGain');
    //     eleBtnLoose = document.getElementById('btnLoose');
    //     document.getElementById('marketTracker').style.display = "block";
    //     document.getElementById('compPro').style.display = "none";
    //     document.getElementById('news').style.display = "none";
    //     document.getElementById('corpAnn').style.display = "none";
    //     document.getElementById('otherMarketInfo').style.display = "none";
    //     let ele = document.getElementById('selectOption');
    //     ele.addEventListener('change', function handleChange(event) {
    //         if (event.target.value === "Daily Market Tracker") {
    //             document.getElementById('marketTracker').style.display = "block";
    //             document.getElementById('compPro').style.display = "none";
    //             document.getElementById('news').style.display = "none";
    //             document.getElementById('corpAnn').style.display = "none";
    //             document.getElementById('otherMarketInfo').style.display = "none";
    //         }
    //         if (event.target.value === "Company Profile") {
    //             document.getElementById('marketTracker').style.display = "none";
    //             document.getElementById('compPro').style.display = "block";
    //             document.getElementById('news').style.display = "none";
    //             document.getElementById('corpAnn').style.display = "none";
    //             document.getElementById('otherMarketInfo').style.display = "none";
    //         }
    //         if (event.target.value === "CM Live News") {
    //             document.getElementById('marketTracker').style.display = "none";
    //             document.getElementById('compPro').style.display = "none";
    //             document.getElementById('news').style.display = "block";
    //             document.getElementById('corpAnn').style.display = "none";
    //             document.getElementById('otherMarketInfo').style.display = "none";
    //         }
    //         if (event.target.value === "Corporate Announcements") {
    //             document.getElementById('marketTracker').style.display = "none";
    //             document.getElementById('compPro').style.display = "none";
    //             document.getElementById('news').style.display = "none";
    //             document.getElementById('corpAnn').style.display = "block";
    //             document.getElementById('otherMarketInfo').style.display = "none";
    //         }
    //         if (event.target.value === "Other Market Info") {
    //             document.getElementById('marketTracker').style.display = "none";
    //             document.getElementById('compPro').style.display = "none";
    //             document.getElementById('news').style.display = "none";
    //             document.getElementById('corpAnn').style.display = "none";
    //             document.getElementById('otherMarketInfo').style.display = "block";
    //         }
    //     });
    // })

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("Index Constituents",window.location.href);
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>index Constituents</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-header'>
                                <h2><span>Index Constituents</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='value-table-main'>
                                <div className="valuetopperselect">
                                    {/* <div className='index-right'> */}
                                    <div className='value-inner-select_I'>
                                        
                                        {/* aria-label="nse bse" */}
                                        <select aria-label="nse bse" onChange={(event) => { setGroupValue(event.target.value); setGroupIndex("BSE_SENSEX"); setGroupIndexNSE("NIFTY") }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>

                                    <div className='value-inner-selectIndex'>
                                        {(groupValue === "BSE") ?
                                            <select aria-label="bse sensex" onChange={(event) => { setGroupIndex(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                                )
                                                )}
                                            </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                                )
                                                )}
                                            </select>}
                                    </div>
                                </div>
                                {/* <hr className="hrIndexCon"></hr> */}
                                <div className='index-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-right'>LTP(&#8377;)</th>
                                                <th className='text-right'>Change(%)</th>
                                                <th className='text-right'>Volume(Nos)</th>
                                                <th className='text-right'>Market Capitalization(&#8377; in CR)</th>
                                                <th className='text-right'>Weight In Index</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ Comp_Name, price, change, Trd_Qty, MCAP, Weightage, CO_CODE, Price, Net_TrdQty }) => (
                                                    <tr>
                                                        < td className="text-left"><h6 onClick={routeChange} data-id={Comp_Name + '-' + CO_CODE}>{Comp_Name}</h6> </td>
                                                        {(groupValue === "BSE") ? <td className="text-right"> {(price != null) ? price.toFixed(2) : 0} </td> : <td className="text-right"> {(Price != null) ? Price.toFixed(2) : 0}</td>}
                                                        <td><p className={change.toFixed(2) > 0 ? "textGreen text-right" : "textRed text-right"}> {change != null ? change.toFixed(2) : 0}
                                                        </p></td>
                                                        <td className="text-right">{(groupValue === "BSE") ? Trd_Qty : Net_TrdQty}</td>
                                                        <td className='text-right'>{(MCAP != null) ? MCAP.toFixed(2) : 0}</td>
                                                        <td className='text-right'>{(Weightage != null) ? Weightage.toFixed(2) : 0}</td>

                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default IndexConstituents;